import { render } from "./iconForward.vue?vue&type=template&id=11cf9670"
import script from "./iconForward.vue?vue&type=script&lang=js"
export * from "./iconForward.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__